import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro' // <-- import styles to be used


//header page
 class Header extends React.PureComponent {



  //header   
   render() {
    const { context } = this.props;
    const authUser = context.authenticatedUser;
//check if auth
    // let log = authUser ? 'FitnessJunkies' : 'MyAuth';
    let log = 'FitnessObsession';


//Opens Side Bar
      function openNav() {

        if (window.innerWidth <= 751) {
          document.getElementById("mySidenav").style.width = "100%"; 
        } else {
          document.getElementById("mySidenav").style.width = "25%";   
        } 
        const dropDownLinks = document.getElementById("mySidenav").childNodes;
        for (let a in dropDownLinks) {
          if (a >= 1)
          dropDownLinks[a].style.fontSize = "25px";
        }
      }
      

      //closes Side Bar
      function closeNav() {
        document.getElementById("mySidenav").style.width = "0%";
        const dropDownLinks = document.getElementById("mySidenav").childNodes;
        for (let a in dropDownLinks) {
          if (a >= 1)
          dropDownLinks[a].style.fontSize = "0px";
        }
      }



    //page
    return (
      <div className="header" style={styles.nav}>
        <div className="bounds" style={styles.cont}>
          <div style={{display: 'inline-flex', position: 'absolute', right: '0%', alignItems: 'center'}}><h1 className="logoH header--logo text-warning">{log}</h1><img className="text-warning" src="https://i.imgur.com/blU6U1S.png" alt="logo for FitnessObsession" style={styles.logo}/></div>

          <nav style={styles.but}>
            {/* {authUser ? ( */}
              <React.Fragment>
                <FontAwesomeIcon className='text-warning' icon={solid('navicon')} style={{cursor: 'pointer', width: "30%", height: "30%"}} onClick={openNav}/>
                <div id="mySidenav" className="sidenav">
                  <span style={{cursor: 'pointer'}} className="closebtn" onClick={closeNav}>&times;</span>
                  <Link className="nav" onClick={closeNav} to="/">Home</Link>
                  <Link className="nav" onClick={closeNav} to="/marketplace">Marketplace</Link>
                  <Link className="nav" onClick={closeNav} to="/reviews">Reviews</Link>
                  <Link className="nav" onClick={closeNav} to="/about">About Us</Link>
                  {/* <Link className="nav" onClick={closeNav} to="/signout" >Sign Out</Link> */}
                </div>

              </React.Fragment>
            {/*  ) : (
                 <React.Fragment>
                   <Link type="button" className="btn btn-warning" to="/signup">Sign Up</Link>
                   <Link type="button"  className="btn btn-warning" style={{marginLeft: '20px'}} to="/signin">Sign In</Link>
                 </React.Fragment>
             )} */}
          </nav>
        </div>
      </div>
    );
  }


};

const styles = {
  nav: {
    width: "100%",
    height: "90px",
    backgroundColor: "#3D3D3D"
  },
  cont: {
    display: 'inline-flex',
    alignItems: "center",
    height: "90px",
    width: "100%",
  },
  but: {
    display: 'inline-flex',
    alignItems: "center",
    position: 'absolute',
    left: '3%',
    height: '40%',
    width: 'auto',
  },
  logo:{
    width: '85px',
    height: '85px',
  }

}

export default Header